import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ListHelp-root_2RJS3"
};
function ListHelp({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "p",
    flexBasis100: true,
    marginY: "none",
    size: "base",
    weight: "regular",
    className: clsx(styles.root, className),
    ...extraProps
  });
}
ListHelp.displayName = 'TypoListHelp';
export { ListHelp };